import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import {
  OAuthModuleConfig,
  OAuthResourceServerErrorHandler,
  OAuthStorage
} from "angular-oauth2-oidc";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { LoggingService, LogLevel } from "../_services/logging.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authStorage = inject(OAuthStorage);
  private errorHandler = inject(OAuthResourceServerErrorHandler);
  private moduleConfig = inject(OAuthModuleConfig, { optional: true });
  private router = inject(Router);
  private loggingService = inject(LoggingService);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let token = this.authStorage.getItem("access_token");
    if (token) {
      this.loggingService.log(
        "AuthInterceptor",
        "Using authenticated HTTP request: " + JSON.stringify(token),
        LogLevel.DEBUG
      );
      let header = "Bearer " + token;
      let headers = req.headers.set("Authorization", header);
      req = req.clone({ headers });
    } else {
      this.loggingService.log(
        "AuthInterceptor",
        "No token found in storage! Using unauthenticated HTTP request!",
        LogLevel.DEBUG
      );
    }
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError(
        (
          httpErrorResponse: HttpErrorResponse,
          _: Observable<HttpEvent<any>>
        ) => {
          if (
            httpErrorResponse.status === HttpStatusCode.Unauthorized ||
            httpErrorResponse.status === HttpStatusCode.Forbidden
          ) {
            this.loggingService.log(
              "AuthInterceptor",
              "Unauthorized or Forbidden error: " +
                JSON.stringify(httpErrorResponse),
              LogLevel.DEBUG
            );
            this.loggingService.log(
              "AuthInterceptor",
              "Redirecting to login page...",
              LogLevel.DEBUG
            );
            this.router.navigate(["login"]);
          }
          return throwError(() => httpErrorResponse);
        }
      )
    );
  }
}
